import { render } from "./StudioWorkerManager.vue?vue&type=template&id=8c7a0438"
import script from "./StudioWorkerManager.vue?vue&type=script&lang=js"
export * from "./StudioWorkerManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__